<template>
  <div class="beneficios">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="page-header">Movimentos ODS</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :show-empty="true"
          title="Listagem"
          api-url="ods/movimentos"
          :fields="fields"
          :initial-page="1"
          :data-path="''"
          :showPrintButton="false"
        >
          <template slot="actions" class="form-group">
            <router-link
              class="btn btn-default"
              :to="'/admin/ods/movimentos/import'"
            >
              <font-awesome-icon :icon="'plus'" /> Importar
            </router-link>
          </template>

          <template slot="rowrender" slot-scope="props">
            <div class="">
              <!-- <button
                title="Editar"
                type="button"
                class="btn btn-primary"
                @click="
                  $router.push({
                    name: 'pagamentos_edit',
                    params: { item: props.rowData }
                  })
                "
              >
                <font-awesome-icon :icon="'edit'" />
              </button> -->
              <button
                title="Excluir"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash-alt'" />
              </button>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import DataTable from '@/components/common/DataTable'
import { request } from '@/request'
import { TheMask } from 'vue-the-mask'

export default {
  components: {
    DataTable,
    TheMask
  },
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'criado_em',
          title: 'Data'
        },
        {
          name: 'instituicao',
          title: 'Instituição'
        },
        {
          name: 'titulo',
          title: 'Titulo'
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  methods: {
    consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh()
      })
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'movimentosODS',
        value: 1
      })
    },
    excluir({ id }) {
      var dt = this.$refs.vuetable

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`ods/movimentos/${id}`)
            .then(() => {
              this.$toastr.s('Item removido com sucesso.')
            })
            .catch(error => {
              const { data } = error.response
              this.$toastr.e(
                'Houve um erro ao tentar excluir, atualize a página e tente novamente'
              )
              console.log(data.msg)
            })
            .then(() => {
              dt.refresh()
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/admin/ods/movimentos/index.vue